import React, { Component } from 'react'
import { Link } from "react-router-dom"
import { Container, CardColumns, Card, Button } from 'react-bootstrap'
import Header from './Header'
import tokenCreator from '../ethereum/tokenCreator'

class Market extends Component {
  constructor(props) {
    super(props)

    this.state = {
      sales: []

    }
  }

  async componentDidMount() {
    const sales = await tokenCreator.methods.getTokenSale().call()
    this.setState({
      sales
    })
  }

  render() {
    return (
      <Container className="text-center">
        <Header />
        <div style={{ marginTop: '15px' }}>
          <CardColumns>
            {this.state.sales.map(sale => (
              <Card>
                <Card.Title>{sale}</Card.Title>
                <Card.Body>
                  <Link to={`/market/${sale}`}><Button variant="outline-success">Details</Button></Link>
                  <Link to={`/buytoken/${sale}`}><Button variant="outline-success">Buy Token</Button></Link>
                </Card.Body>
              </Card>
            ))}
          </CardColumns>
        </div>
      </Container>
    )
  }
}

export default Market;
